import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

/**
 * Purely presentational 2-row compact card for International Market items.
 */
const InternationalCardUI = ({ 
  name, 
  price, 
  change, 
  onClick, 
  onMouseEnter, 
  onMouseLeave,
  pricePrecision = 2
}) => {
  const ltpValue = parseFloat(price || 0);
  const isPositive = (change || 0) >= 0;
  const absChange = Math.abs(change || 0).toFixed(pricePrecision);

  return (
    <Paper 
      elevation={0}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{ 
        minWidth: { xs: 150, sm: 180, lg: 200 },
        maxWidth: 240,
        p: { xs: 1.5, lg: 2 }, 
        border: '1px solid',
        borderColor: '#E0E0E0',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: { xs: 72, lg: 84 },
        overflow: 'hidden',
        position: 'relative',
        transition: 'all 0.2s',
        cursor: onClick ? 'pointer' : 'default',
        backgroundColor: 'background.paper',
        '&:hover': {
           boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
           borderColor: 'text.secondary',
           transform: onClick ? 'translateY(-2px)' : 'none',
        }
      }}
    >
      {/* 1st row: Name (Left) and Change (Right) */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
        <Typography variant="subtitle2" fontWeight="700" noWrap sx={{ lineHeight: 1.5, fontSize: { xs: '0.85rem', sm: '0.95rem', lg: '1rem' }, maxWidth: '65%' }}>
          {name}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {isPositive ? (
            <ArrowDropUpIcon sx={{ color: 'success.main', fontSize: 18, mr: -0.5 }} />
          ) : (
            <ArrowDropDownIcon sx={{ color: 'error.main', fontSize: 18, mr: -0.5 }} />
          )}
          <Typography 
            variant="caption" 
            fontWeight="700"
            color={isPositive ? 'success.main' : 'error.main'}
            sx={{ fontSize: { xs: '0.65rem', lg: '0.75rem' } }}
          >
            ₹{absChange}
          </Typography>
        </Box>
      </Box>
      
      {/* 2nd row: Price */}
      <Typography variant="body1" noWrap sx={{ mt: 'auto', color: 'text.secondary', fontWeight: 600, fontSize: { xs: '0.75rem', sm: '0.8rem', lg: '0.875rem' } }}>
        ₹{ltpValue.toLocaleString('en-IN', { minimumFractionDigits: pricePrecision, maximumFractionDigits: pricePrecision })}
      </Typography>
    </Paper>
  );
};

export default InternationalCardUI;
